var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-forbidden__wrapper"},[_c('h1',{staticClass:"h-font-22"},[_vm._v(" "+_vm._s(_vm.$t('FORBIDDEN.NOT.MANAGER'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }